import type { IconProps } from '../types/IconProps.ts';
export const Calendar: IconProps = {
    name: 'Calendar',
    children: [
        `<rect width="18" height="18" x="3" y="4" rx="2" />`,
        `<path d="M8 2v4M16 2v4M3 10h18" />`,
    ]
};